import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CheckCircle, ArrowRight, Sparkles } from 'lucide-react';

export default function TrialSuccess() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md text-center">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle size={44} className="text-green-600" />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-3">{t('trialSuccess.title', 'You’re All Set!')}</h1>
        <p className="text-gray-600 mb-2">
          {t('trialSuccess.body', 'Your 14-day free trial has started. You have full access to all features.')}
        </p>
        <p className="text-sm text-gray-500 mb-8">
          {t('trialSuccess.note', 'No credit card required during the trial. We’ll remind you before it ends.')}
        </p>

        <div className="bg-white rounded-2xl shadow-lg p-6 mb-6">
          <h3 className="font-semibold text-gray-900 mb-4 flex items-center gap-2 justify-center">
            <Sparkles size={18} className="text-primary" /> {t('trialSuccess.quickStart', 'Quick Start Guide')}
          </h3>
          <ul className="text-left space-y-3">
            {[
              t('trialSuccess.step1', 'Add your staff members and their roles'),
              t('trialSuccess.step2', 'Set up team availability preferences'),
              t('trialSuccess.step3', 'Create your first weekly rota'),
              t('trialSuccess.step4', 'Try AI auto-fill to assign shifts'),
              t('trialSuccess.step5', 'Publish and notify your team'),
            ].map((step, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="w-6 h-6 rounded-full bg-primary text-white text-xs font-bold flex items-center justify-center flex-shrink-0 mt-0.5">
                  {i + 1}
                </span>
                <span className="text-sm text-gray-700">{step}</span>
              </li>
            ))}
          </ul>
        </div>

        <Link
          to="/dashboard"
          className="inline-flex items-center gap-2 bg-primary text-white px-8 py-3 rounded-xl font-semibold hover:bg-primary-dark transition-colors"
        >
          {t('trialSuccess.goToDashboard', 'Go to Dashboard')} <ArrowRight size={18} />
        </Link>
      </div>
    </div>
  );
}
